const getValidationState = store => store.validation;
const getValidations = store => (getValidationState(store) ? getValidationState(store).validations : null);
const getExternalValidationsLoading = store => (getValidationState(store) ? getValidationState(store).loadingExternalValidations : null);
const getEnableExternalValidations = store => (getValidationState(store) ? getValidationState(store).enableExternalValidations : null);
export { getValidationState, getValidations, getExternalValidationsLoading, getEnableExternalValidations };
